import { format, addDays } from 'date-fns'
import utcDate from '../utility/utcDate'

export const exploitsDatetime = datetime => {
  // One off request to handle an inacurate datetime value
  if (datetime === '2017-02-15') {
    return 'mid-Feb 2017'
  } else {
    return datetime
  }
}

export const riverIceUtcDatetime = datetime => {
  // One off to handle river ice datetime timezone error
  if (!datetime) {
    return null
  }
  const datetimeObject = typeof(datetime) === 'string' ? new Date(datetime) : datetime
  const newDatetime = format(addDays(datetimeObject, 1), 'yyyy-MM-dd')

  if (newDatetime === '2020-01-01') {
    return '2019-01-01'
  }
  return newDatetime
}

export const utcDatetime = datetime => {
  console.log({ datetime })
  if (!datetime) {
    return null
  }
  const newDatetime = utcDate(datetime)
  console.log({ newDatetime })
  return newDatetime
}



// WEBPACK FOOTER //
// ./src/transforms/transforms.js